module.exports = __webpack_public_path__ + "static/img/post_1111.f8e512e0.gif";